// "Could not load this — Try again" for the kitchen tablet's lists and panels
// (pilot fix, Batch 5 lane tablet): a failed fetch used to look like "Loading…"
// forever or like an empty list.
import { Button } from '@/components/ui/button'
import { T } from '@/lib/inventoryFlow/strings'

export function LoadError({ onRetry, busy }: { onRetry: () => void; busy?: boolean }) {
  return (
    <div className="space-y-3 rounded-lg border p-4" role="alert">
      <p className="text-sm text-muted-foreground">{T.loadFailed}</p>
      <Button variant="outline" size="sm" disabled={busy} onClick={onRetry}>{T.retry}</Button>
    </div>
  )
}
